
export default function PCRepair() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Hardware Diagnostics',
      description: 'Complete system analysis to identify and fix hardware issues including motherboards, RAM, and power supplies.'
    },
    {
      icon: 'ri-computer-line',
      title: 'Screen Replacement',
      description: 'Professional display repair and replacement for laptops and desktop monitors with quality parts.'
    },
    {
      icon: 'ri-hard-drive-2-line',
      title: 'Storage Upgrades',
      description: 'Upgrade to faster SSDs or increase storage capacity to improve your computer performance.'
    },
    {
      icon: 'ri-cpu-line',
      title: 'Component Repair',
      description: 'Expert repair of graphics cards, cooling systems, and other critical PC components.'
    }
  ];

  return (
    <section id="pc-repair" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-block px-4 py-1.5 border border-teal-600 text-teal-600 text-xs font-semibold rounded-full mb-4">
            PC REPAIR SERVICES
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Complete PC Repair <br className="hidden sm:block" />Solutions
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            From hardware fixes to component upgrades, we handle all your desktop and laptop repair needs with expertise and care
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 rounded-lg hover:bg-teal-600 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-full mb-4 sm:mb-6 group-hover:bg-white/20 transition-colors">
                <i className={`${service.icon} text-2xl text-teal-600 group-hover:text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 group-hover:text-white transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed group-hover:text-white/90 transition-colors">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 sm:mt-16 bg-white rounded-2xl p-6 sm:p-10 shadow-sm">
          <div className="grid md:grid-cols-2 gap-8 sm:gap-10 items-center">
            <div>
              <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
                Why Choose Our PC Repair Service?
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed text-sm sm:text-base">
                With over 12 years of experience, I provide fast, reliable, and affordable PC repair services. We use only quality parts and gurantee and fast afforable service
              </p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm sm:text-base">Next day service on most repairs</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm sm:text-base">$50 Diagnostic fee (This fee will be Waived if you choose to have the repair done) Price is $50 per hour(1 hour Minuim) plus parts on all repairs.</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-check-line text-teal-600 text-xl mt-0.5 flex-shrink-0"></i>
                  <span className="text-gray-700 text-sm sm:text-base">Transparent pricing with no hidden fees. We accept Cash, Venmo, PayPal, and Cash App</span>
                </li>
              </ul>
            </div>
            <div className="relative h-64 sm:h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/b002bd073c5726c4b26deb886d6c4f18.jpg"
                alt="PC Repair Service"
                className="w-full h-full object-cover object-top rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
